function NumberFilter (numeral) {
  function filter (value) {
    return numeral(value).format('0,0')
  }

  return {
    filter
  }
}

export default NumberFilter
